import { useTranslation } from '@ecomm/i18n'
import { BusinessPlanBenefits } from '../BusinessPlanBenefits'
import type { MonitoringChoiceType } from '../types'
import { ChangeBusinessUnit } from './ChangeBusinessUnit'

type TopContentProps = {
  readonly monitoringChoice: MonitoringChoiceType
}

export function TopContent({ monitoringChoice }: TopContentProps) {
  const { t } = useTranslation('maps')

  return (
    <section data-testid="MonitoringTopContent" className="w-full mt-10">
      <div className="flex w-full flex-col items-center">
        <h2 className="mb-6 text-center text-3xl md:max-w-5xl md:text-6xl">
          {t(`${monitoringChoice}.business.title`)}
        </h2>
        <p className="md:max-w-3xl text-center text-base">
          {t(`${monitoringChoice}.business.subtitle`)}
        </p>
      </div>
      <ChangeBusinessUnit isBusiness={true} />
      <BusinessPlanBenefits hideTitle={true} />
    </section>
  )
}
